import { memo } from 'react';
import { Helmet } from 'react-helmet-async';

import { Wrapper } from './styles';

import packageJSON from '../../../../package.json';

interface Props {
  children: React.ReactNode;
}

export const Minimal = memo(({ children }: Props) => {
  return (
    <>
      <Helmet>
        <title>{`${packageJSON.appName} - Software for Mental Health Professionals`}</title>
        <meta name="description" content={`${packageJSON.appName} - Software for Mental Health Professionals`} />
      </Helmet>
      <Wrapper>{children}</Wrapper>
    </>
  );
});

export default Minimal;
